
import { mapState, mapGetters, mapMutations, mapActions, Swiper } from 'vuex';
import dateFormat from 'vux/src/tools/date/format.js'

import conf from './../../config/base.js';
import { getDepponReimBurseType, formatDateTime2,operateInvoice,tip} from '@/common/js/common.js';
import dataLack from '@/components/dataLack.vue'

import {

invoiceTitleType,
documentTypeArray,

invoiceStatusArray,
invoiceReimbursementStatus,
discernStatus,
invoiceCheckStatus,
tenantCode,
depponReimBurseType,
invoiceExtractStatus,
} from '@/common/js/const';
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Box from 'vux/src/components/box/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'


export default {

directives: {
TransferDom,
},
components: {
Group,
XDialog,
Cell,

CellBox,
XHeader,

Box,
XButton,
CellFormPreview,
Actionsheet,
XTable,
dataLack
},
data() {
return {
invoiceReimbursementStatus: invoiceReimbursementStatus,
discernStatus: discernStatus,
invoiceExtractStatus: invoiceExtractStatus,
piaoCode: '',
invoiceCheckStatus: invoiceCheckStatus,


showMore: false,
showMoreBtn: true,
shareMenus: {
edit: this.$t('编辑'),
delete: '<span class="text-error">' + this.$t('删除') + '</span>',
},

showInfoForMissing: false,
showCheckResultDialog: false,
showSellerDetail: false,
showBuyerDetail: false,
showGoodsDetail: false,
showWorkFlow: false,
checkResult: '',
showReturned: false,
returnedMsg: '',
imageSlide1: [
{
src: '',
msrc: '',
alt: '',
title: '',
w: 600,
h: 400,
pid: 'image-one',
},
],
reimburseList: [],


invoiceInfo: {
documentType: '20001001',
documentTypeName: '增值税普通发票',
groupFlag: '',

thumbnail: '',
savedByOther: 0, //是否已被他人保存
buyer: {
name: '',
taxNumber: '',
bank: '',
bankAccount: '',
address: '',
tel: '',
},
buyerFormDetail: [],
seller: {
name: '',
taxNumber: '',
bank: '',
bankAccount: '',
address: '',
tel: '',
},
sellerFormDetail: [],
goods: '', //地下车库使用费等商品
goodsFormDetail: [
{
label: this.$t('名称'),
value: this.$t('金额/税率'),
},
],
labels: [],
faPiaoHaoMa: [],
},
imgSize: 0, //存放发票图片的总个数 在切换nav时 调用多票接口时获取图片的个数
activeImgItem: 0, //存放当前显示图片的位置
piaoList: [], //后台获取的多票信息进行存放
invoice: [], //往页面写数据
piaoCode: [],
piaoImgList: [], //每一种发票类型的所有图片
piaoCodeList: [],
train: false,
taxi: false,
plane: false,
quota: false,
vehicle: false,
car: false,
carErshou: false,
rollTicket: false,
generalTicket: false,
activeClick: '',
piaoNavListObj: {
50001010: '火车票',
50001011: '出租车票',
50001009: '行程单',
50001013: '定额发票',
50001001: '机动车发票',
50001016: '客运汽车票',
50001015: '二手车票',
40001001: '卷票',
20001001: '普票',

10001001: '专票',
10001003: '电子专票',

30001001: '电子普票',

30001002: '通行费票',
90009999: '附件',
90001007: '二维码',
90001006: '结算单',
50001014: '过路费',
50001002: '地方通用机打发票',
50001018: '地方通用电子发票'
},
invoiceFlag: {
1: '验真成功',
},
yanzhenStatus: '',
chufariqi: '',
chufashijian: '',

images: [],
activeIndex: 0,
};
},
created() {},
activated() {},
/**计算属性 将状态表中的数据 映射出来*/
computed: {},
filters: {},
/**初始化的时候调用  类似于 ready */
mounted() {

var $self = this;

var __id = $self.$route.params.id;
localStorage.setItem('taskId', __id);
$self.loadData(__id);
},
methods: {
prewImage(index) {
this.images = [].concat(this.piaoImgList);
},
addInvoice(){
this.$router.push({
path: '/invoice/update/' + 'addInvoice',
query: { taskId: this.invoice.taskId,isMultipleResult:this.invoice.isMultipleResult},
});
},
changeImageInfo(params) {
console.log(params);
this.piaoDetail(this.piaoCode, params);
},
pageGoBack() {

this.$router.push('/invoice/index');
localStorage.removeItem('documentType');














},

loadData(invoiceId) {
var $self = this;
$self.$webapi
.oneInvoice({
taskId: invoiceId,
})
.then(res => {
$self.$clog(res.data);
console.log('res: ', res)
if (res.data.status == 1) {
if(JSON.stringify(res.data.result) == "{}"){

$self.$vux.alert.show({
title: '提示',
content: '当前多票影像已全部删除，请到我的票夹查看其他票据影像',
onHide () {
$self.$router.push('/invoice/index')
}
})
}
$self.piaoCodeList.length = 0;
$self.invoice.length = 0;
$self.piaoList = res.data.result;
let docM = localStorage.getItem('documentType');
let lastInvoiceFlag = false
for (let item in res.data.result) {
if(docM == item){
lastInvoiceFlag = true
}
$self.piaoCodeList.push(item);
}
if (docM && lastInvoiceFlag) {
for (let item = 0; item < $self.piaoCodeList.length; item++) {
if (docM == $self.piaoCodeList[item]) {
$self.piaoDetail($self.piaoCodeList[item]);
return;
}
}
} else {
localStorage.setItem('documentType', $self.piaoCodeList[0]);
$self.piaoDetail($self.piaoCodeList[0]);
}
}
});

},
piaoDetail(obj, index = 0) {
var $self = this;
this.piaoCode = obj;
this.activeIndex = index;
if (localStorage.getItem('documentType')) {
$self.activeClick = localStorage.getItem('documentType');
localStorage.removeItem('documentType');
} else {
$self.activeClick = obj;
}
if ($self.piaoList[obj]) {
$self.invoice = $self.piaoList[obj][index];
$self.piaoImgList.length = 0;
for (let item in $self.piaoList[obj]) {
$self.piaoImgList.push($self.piaoList[obj][item].imgUrl);
}
} else {
return false;
}
},


shareMenusClick(key, item) {
var $self = this;
if (key == 'edit') {

if (!operateInvoice(this.invoice,'edit')) {




return false;
} else {
let path = '/invoice/moreUpdate/' + $self.invoice.invoiceId + '/' + $self.invoice.documentType
localStorage.setItem('forwardPath',this.$route.path)
$self.$router.push(path);
}
}else if(key == 'delete'){
if(!operateInvoice(this.invoice,'del')){
return false
}
this.$vux.confirm.show({
title: this.$t('提示'),
content: this.$t('删除警告'),
confirmText: this.$t('确定'),
cancelText: this.$t('取消'),
onCancel() {
},
onConfirm: () => {
let params = {}
params.invoiceId = this.invoice.invoiceId
this.$webapi.deleteInvoice(params).then(res => {
this.$clog(res.data);
if (res.data.status == 1) {
this.loadData(localStorage.getItem('taskId'));
this.$vux.toast.show({
text: this.$t('操作成功'),
type: 'text',
});
} else {
this.$vux.toast.show({
text: res.data.msg,
type: 'text',
});
}
});
},
});
}
},


showReimbursement(groupFlag) {
var $self = this;
if (groupFlag == 'futureland') {
return false;
} else {
return true;
}
},

showHasTitle(groupFlag) {
if (groupFlag == tenantCode.shenhua) {
return true;
} else {
return false;
}
},

/**加载验真结果 */
loadCheckResult(invoiceId) {
var $self = this;
$self.$webapi
.oneInvoiceCheckResult({
invoiceId: invoiceId,
})
.then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
var resData = res.data.result;
$self.checkResult = resData.verifyRemark;
} else {
$self.checkResult = '';
}
});
},
prevImg(num) {
var $self = this;
if (activeImgItem < imgSize) {
$self.activeImgItem = num + 1;
}
},

isZengZhiShuiPiao(documentType, verifyFlag) {
var $self = this;
try {
return (
documentType.indexOf('1000') == 0 ||
documentType.indexOf('2000') == 0 ||
documentType.indexOf('3000') == 0 ||
documentType.indexOf('4000') == 0 ||
documentType.indexOf('50001001') == 0 ||
documentType.indexOf('50001017') == 0 ||
(documentType.indexOf('50001009') == 0 && verifyFlag != '') 
);
} catch (error) {
return false;
}
},

showReimbursement(groupFlag) {
var $self = this;
if (groupFlag == 'futureland') {
return false;
} else {
return true;
}
},

showHasTitle(groupFlag) {
if (groupFlag == tenantCode.shenhua) {
return true;
} else {
return false;
}
},

isFeiJiHuoCheChuZuChe(documentType) {
var $self = this;
return (
documentType.indexOf('50001010') == 0 ||
documentType.indexOf('50001009') == 0 ||
documentType.indexOf('50001011') == 0
);
},

isOtherPiao(documentType) {
var $self = this;
return (
documentType.indexOf('90009999') == 0 ||
documentType.indexOf('50009999') == 0 ||
documentType.indexOf('90001006') == 0
);
},
},
};
